import React from "react";

import { HubDialogWrapper } from "../HubDialogWrapper";
import MergeCustomerContent from "./MergeCustomerContent";

export const MergeCustomerDialog = () => {
  const name = "merge-customers";

  return (
    <HubDialogWrapper maxWidth="sm" name={name}>
      <MergeCustomerContent />
    </HubDialogWrapper>
  );
};

export default MergeCustomerDialog;
